// Angular
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
// RxJS
import { Observable } from "rxjs";
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
// Models
import { ScopeModel } from "..";
import { environment } from "../../../../environments/environment";

const API_SCOPES_URL = environment.API_URL + "api/reaches";

@Injectable()
export class ScopesService {
  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {}

  // CREATE =>  POST: add a new scope to the server
  createScope(scope: ScopeModel): Observable<ScopeModel> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<ScopeModel>(API_SCOPES_URL, scope, { headers: httpHeaders });
  }

  // READ
  getAllScopes(): Observable<ScopeModel[]> {
    return this.http.get<ScopeModel[]>(API_SCOPES_URL);
  }

  getScopeById(scopeId: number): Observable<ScopeModel> {
    return this.http.get<ScopeModel>(API_SCOPES_URL + `/${scopeId}`);
  }

  // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
  // items => filtered/sorted result
  // Server should return filtered/sorted result
  findScopes(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_SCOPES_URL + "/find";
    return this.http.post<QueryResultsModel>(url, queryParams, { headers: httpHeaders });
  }

  // UPDATE => PUT: update the scope on the server
  updateScope(scope: ScopeModel): Observable<any> {
    const httpHeader = this.httpUtils.getHTTPHeaders();
    return this.http.put(API_SCOPES_URL + `/${scope.id}`, scope, { headers: httpHeader });
  }

  // UPDATE Status
  updateStatusForScope(scopes: ScopeModel[], status: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {
      scopesForUpdate: scopes,
      newStatus: status
    };
    const url = API_SCOPES_URL + "/updateStatus";
    return this.http.put(url, body, { headers: httpHeaders });
  }

  // DELETE => delete the scope from the server
  deleteScope(scopeId: number): Observable<ScopeModel> {
    const url = `${API_SCOPES_URL}/${scopeId}`;
    return this.http.delete<ScopeModel>(url);
  }

  deleteScopes(ids: number[] = []): Observable<any> {
    const url = API_SCOPES_URL + "/deleteScopes";
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = { scopeIdsForDelete: ids };
    return this.http.put<QueryResultsModel>(url, body, { headers: httpHeaders });
  }
}
